<template>
  <tr class="v2-affiliates-detail">
    <td :colspan="colspan" class="v2-affiliates-detail__cell">
      <div class="v2-affiliates-detail__inner">
        <div
          v-if="!fieldGroups.length"
          class="v2-affiliates-detail__empty"
        >
          <p class="v2-body v2-body--sm v2-body--muted">
            No hay campos adicionales para mostrar.
          </p>
        </div>
        <div v-else class="v2-affiliates-detail__groups">
          <section
            v-for="(group, gi) in fieldGroups"
            :key="group._id || `g-${gi}`"
            class="v2-affiliates-detail__group"
          >
            <h4
              v-if="group.title"
              class="v2-affiliates-detail__group-title"
            >
              {{ group.title }}
            </h4>
            <dl class="v2-affiliates-detail__fields">
              <div
                v-for="(field, fi) in group.fields"
                :key="`${group._id || 'g'}-${field._id || field.formattedName || field.name || fi}`"
                class="v2-affiliates-detail__field"
              >
                <dt>{{ field.name }}</dt>
                <dd>{{ formatFieldValue(field.value) }}</dd>
              </div>
            </dl>
          </section>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { formatFieldValue } from "../affiliatesHelpers";

export default {
  name: "AffiliateDetailRow",
  props: {
    affiliate: { type: Object, required: true },
    colspan: { type: Number, default: 4 },
  },
  computed: {
    fieldGroups() {
      const memberData = Array.isArray(this.affiliate.memberData)
        ? this.affiliate.memberData
        : [];
      const cleaned = memberData.filter((f) => f && f.fieldType !== "DOC");
      if (cleaned.length === 0) return [];

      const sectionsMap = new Map();
      let unsectioned = [];
      for (const field of cleaned) {
        const sectionRef = field.section;
        const sectionId =
          sectionRef && typeof sectionRef === "object"
            ? sectionRef._id || sectionRef.id
            : sectionRef || null;
        const sectionName =
          sectionRef && typeof sectionRef === "object"
            ? sectionRef.name
            : null;
        if (sectionId) {
          if (!sectionsMap.has(sectionId)) {
            sectionsMap.set(sectionId, {
              _id: sectionId,
              title: sectionName || `Sección ${sectionId}`,
              fields: [],
            });
          }
          sectionsMap.get(sectionId).fields.push(field);
        } else {
          unsectioned.push(field);
        }
      }

      const groups = [];
      if (unsectioned.length) {
        groups.push({
          _id: null,
          title: "Datos del submiembro",
          fields: unsectioned,
        });
      }
      sectionsMap.forEach((g) => groups.push(g));
      return groups;
    },
  },
  methods: {
    formatFieldValue,
  },
};
</script>

<style scoped>
.v2-affiliates-detail {
  background-color: var(--color-neutral-50);
}

.v2-affiliates-detail__cell {
  padding: 0;
  border-bottom: 1px solid var(--color-border);
}

.v2-affiliates-detail__inner {
  padding: var(--space-5) var(--space-6) var(--space-6) var(--space-6);
  animation: v2-affiliates-detail__slide 200ms ease-out;
}

.v2-affiliates-detail__empty {
  color: var(--color-text-muted);
}

.v2-affiliates-detail__groups {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.v2-affiliates-detail__group-title {
  font-family: var(--font-body);
  font-size: var(--fs-label-md);
  font-weight: var(--fw-bold);
  color: var(--color-primary);
  margin: 0 0 var(--space-2) 0;
  padding-bottom: var(--space-1);
  border-bottom: 1px solid var(--color-border);
}

.v2-affiliates-detail__fields {
  margin: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-3);
}

@media (min-width: 600px) {
  .v2-affiliates-detail__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .v2-affiliates-detail__fields {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.v2-affiliates-detail__field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.v2-affiliates-detail__field dt {
  margin: 0;
  font-size: var(--fs-label-xs);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wider);
  color: var(--color-text-muted);
  font-weight: var(--fw-semibold);
}

.v2-affiliates-detail__field dd {
  margin: 0;
  color: var(--color-text);
  font-size: var(--fs-body-sm);
  word-break: break-word;
}

@keyframes v2-affiliates-detail__slide {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
